import {
  Button,
  Col,
  Divider,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tabs,
  Tag,
  Typography,
} from 'antd';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../../webux-layouts/WebUxPage';
import { UserAvatar, UserNameView } from '../../../../../components/atoms/UserAvatar';
import { GoalSummary, Team } from '../../../../../entity/Team';
import { useConnection, useUserInfo } from '../../../../../connection/Application';
import { FlexBox } from '../../../../../components/atoms/FlexBox';
import { PerformanceCycle } from '../../../../../entity/PerformanceCycle';
import { TeamUserPage } from './TeamUser';
import { ControlOutlined, TeamOutlined, ApartmentOutlined, LikeOutlined } from '@ant-design/icons';
import Configurations from './Configurations';
import { CycleToggle } from '../../../../../components/atoms/ItemToggle';
import { InternalCustomerManger } from './internalCustomerManger';
import SelectSearch from '../../../../../form/adapters/selectSearch';
import { useQueryParam } from 'use-query-params';
import { PageHeader } from '@ant-design/pro-layout';
import { SubordinateReviewManger } from './SubordinateReviewManger';
const { TabPane } = Tabs;
const { Text } = Typography;

export const TeamSetupPage: FC = () => {
  const params = useParams<{ id: string; name: string }>();
  const [cycle, setCycle] = useQueryParam<number | undefined>('cycle');
  const user = useUserInfo();
  const [isLeader, setIsLeader] = useState<boolean>(false);
  const [isSupervisor, setIsSupervisor] = useState<boolean>(false);
  const [isAdminOrHr, setIsAdminOrHr] = useState<boolean>(false);
  const cycleRef = useRef(cycle);
  const history1 = useHistory();
  const [team, setTeam] = useState<Team>();
  const [goalSummary, setGoalSummary] = useState<GoalSummary>();
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [criteriaSet, setCriteriaSet] = useState<any[]>([]);
  const [teamSet, setTeamSet] = useState<any[]>([]);
  const [userSet, setUserSet] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loading1, setLoading1] = useState<boolean>(true);
  const [authorized, setAuthorized] = useState<boolean>(true);
  const [fetch, setFetch] = useState<boolean>(false);
  const connection = useConnection();
  const [value, setValue] = useState<number | undefined>();
  const [internalTeamCustomers, setInternalTeamCustomers] = useState<any[]>([]);
  const [internalUserCustomers, setInternalUserCustomers] = useState<any[]>([]);
  const [subordinate, setSubordinate] = useState<any[]>([]);
  const [teamUsers, setTeamUsers] = useState<any[]>([]);
  const [cycleMap, setCycleMap] = useState<Record<number, { id: string; name: string }>>({});
  const showPeerReviewSettings = isAdminOrHr || isSupervisor || !isLeader;
  const showTeamLeadsTab = isAdminOrHr || isSupervisor || !isLeader;

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setCycle(value.closestCycle.id, 'replace');
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setCycle]);

  useEffect(() => {
    setLoading(true);
    if (cycle) {
      setGoalSummary(undefined);
      setValue(undefined);
      connection
        .get(`goals/getTeamGoalSummary/${params.id}/${cycle}`)
        .then(
          (res: {
            teams: any[];
            users: any[];
            teamUsers: any[];
            subTeams: any[];
            team: any;
            goalSummary: GoalSummary;
            criteriaSet: { data: any[]; total: number };
            cycleMap?: Record<number, { id: string; name: string }>;
          }) => {
            if (res.cycleMap) {
              setCycleMap((prev) => ({ ...prev, ...res.cycleMap }));
            }
            setCriteriaSet(res.criteriaSet.data);
            setTeam(res.team);
            setTeamSet(res.teams);
            setUserSet(res.users);
            setTeamUsers(res.teamUsers);
            setGoalSummary(res.goalSummary);

            if (user) {
              const isAdminOrHr = user.roles?.includes('admin') || user.roles?.includes('hr');
              setIsAdminOrHr(isAdminOrHr ?? false);
              const isLead = res.team?.leads?.some((l: any) => l.id === user.userId);
              const isSuper = res.team?.supervisors?.some((s: any) => s.id === user.userId);
              setIsLeader(isLead);
              setIsSupervisor(isSuper);

              if (isAdminOrHr || isLead || isSuper) {
                setAuthorized(true);
              } else {
                setAuthorized(false);
              }
            }

            if (res.goalSummary?.criteriaSetId) setValue(res.goalSummary?.criteriaSetId);
            // setInternalValue(goalSummary?.internalCustomerCriteriaSetId ?? 0);
            const dataArr: any[] = [];
            const dataArr2: any[] = [];
            const dataArr3: any[] = [];

            let internalCustomer: any;
            for (const item of res.goalSummary?.internalCustomers ?? []) {
              if (item.type === 'team') {
                internalCustomer = res.teams.find((team) => item.reviewer === team.id);
              } else {
                internalCustomer = res.users.find((user) => item.reviewer === user.id);
              }
              const item2 = res.criteriaSet.data.find(
                (criteria) => item.internalCustomerCriteriaSetId === criteria.id,
              );
              if (internalCustomer && item2 && item.type === 'team') {
                dataArr.push({
                  internalCustomer,
                  criteriaSet: item2,
                  key: item?.id,
                  internalCustomerName: internalCustomer?.value,
                  criteriaSetName: item2?.name,
                  type: item.type,
                  weight: item.weight,
                  leaderWeight: item?.leaderWeight ?? item.weight,
                  reviewType: item.reviewType,
                  status: item.status,
                });
              } else if (internalCustomer && item2 && item.type === 'user') {
                dataArr2.push({
                  internalCustomer,
                  criteriaSet: item2,
                  key: item?.id,
                  internalCustomerName: internalCustomer?.value,
                  criteriaSetName: item2?.name,
                  type: item.type,
                  weight: item.weight,
                  leaderWeight: item?.leaderWeight ?? item.weight,
                  reviewType: item.reviewType,
                  status: item.status,
                });
              }
            }

            let subordinate1: any;
            for (const item of res.goalSummary?.subordinateReviews ?? []) {
              if (item.type === 'team') {
                subordinate1 = res.teams.find((team) => item.reviewer === team.id);
              } else {
                subordinate1 = res.users.find((user) => item.reviewer === user.id);
              }
              const item2 = res.criteriaSet.data.find(
                (criteria) => item.subordinateReviewCriteriaSetId === criteria.id,
              );
              if (subordinate1 && item2) {
                dataArr3.push({
                  internalCustomer: subordinate1,
                  criteriaSet: item2,
                  key: item?.id,
                  internalCustomerName: subordinate1?.value,
                  criteriaSetName: item2?.name,
                  type: item.type,
                  weight: item.weight,
                  reviewType: item.reviewType,
                  user: item.user,
                  status: item.status,
                });
              }
            }
            setSubordinate(dataArr3);
            setInternalTeamCustomers(dataArr);
            setInternalUserCustomers(dataArr2);
          },
        )
        .catch((err: any) => {
          if (err?.response?.status === 403) {
            setAuthorized(false);
          }
        })
        .finally(() => {
          setLoading1(false);
          setLoading(false);
        });
    }
  }, [connection, cycle, params.id, fetch, user]);

  const setCriteria = useCallback(
    (e) => {
      setLoading(true);
      if (goalSummary) {
        connection.patch(`goals/setCriteriaSet/${goalSummary.id}/${e}`).then(() => {
          setLoading(false);
        });
      }
    },
    [connection, goalSummary],
  );

  const publish = useCallback(
    (e) => {
      setLoading(true);
      if (goalSummary && e) {
        connection.patch(`goals/publish/${e}/${goalSummary.id}`).then(() => {
          setFetch(!fetch);
        });
      }
    },
    [connection, fetch, goalSummary],
  );

  const submitConfiguration = useCallback(
    (values: any, type: 'team' | 'lead') => {
      const data: any[] = [];
      data.push({ ...values.internalCustomer, type: 'internalCustomer' });
      data.push({ ...values.supervisorFeedBack, type: 'supervisorFeedBack' });
      data.push({ ...values.peerReview, type: 'peerReview' });
      data.push({ ...values.teamPerformance, type: 'teamPerformance' });
      connection
        .post(`teams/${params.id}/configuration`, {
          cycleId: cycle,
          configurations: data.map((e) => ({
            checked: e.checked,
            type: e.type,
            weight: e.weight,
          })),
          type,
        })
        .catch((e) => console.log(e));
    },
    [connection, cycle, params.id],
  );

  if (!loading1 && !authorized) {
    return (
      <WebUxPage>
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Button type="primary" onClick={() => history1.push(`/webux/setup?cycle=${cycle}`)}>
              Back Home
            </Button>
          }
        />
      </WebUxPage>
    );
  }

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${decodeURIComponent(params?.name)}`}
        subTitle="360° Configuration"
        onBack={() => history1.push(`/webux/setup?cycle=${cycle}`)}
        breadcrumb={{
          items: [
            {
              path: 'setup',
              title: `360° Configuration`,
            },
            {
              path: '',
              title: `${decodeURIComponent(params?.name)}`,
            },
          ],
        }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <Space direction={'vertical'} style={{ width: '100%', marginBottom: 16 }} size={16}>
            <FlexBox horizontalAlign={'left'}>
              <CycleToggle
                value={parseInt(`${cycle}`)}
                onChange={(value) => {
                  if (value && cycleMap[value]) {
                    history1.push(
                      `/webux/setup/team-setup/${cycleMap[value].id}/${cycleMap[value].name}?cycle=${value}`,
                    );
                  } else {
                    setCycle(value, 'replace');
                  }
                }}
                data={cycles}
              />
            </FlexBox>
          </Space>
          {loading1 ? (
            <Spin
              spinning={loading1}
              style={{
                paddingTop: '10%',
                paddingBottom: '10%',
                paddingLeft: '49%',
                textAlign: 'center',
                borderRadius: '4px',
              }}
            />
          ) : (
            <Spin spinning={loading}>
              <div className="teams-view">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}>
                    <Space size={24} align={'start'} style={{ flex: 1 }}>
                      <UserAvatar type={'team'} size={60} src={team?.image} />
                      <Space direction={'vertical'}>
                        <Space>
                          <Typography.Title style={{ fontSize: '25px' }}>
                            {team?.name}
                          </Typography.Title>
                          <Tag color={team?.teamType?.color}>{team?.teamType?.name}</Tag>
                        </Space>
                        <Typography.Paragraph>{team?.description}</Typography.Paragraph>
                      </Space>
                    </Space>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: 50,
                        paddingRight: 100,
                      }}>
                      <Typography.Title level={5}>Parent Team</Typography.Title>
                      <Space size={24} style={{ alignItems: 'baseline' }}>
                        {team?.parent && (
                          <UserAvatar type={'team'} size={40} src={team?.parent?.image} />
                        )}
                        <Typography.Paragraph>
                          {team?.parent?.name ?? 'Not Set'}
                        </Typography.Paragraph>
                      </Space>
                    </div>
                  </div>
                </div>
                <Divider style={{ marginTop: 0, marginBottom: 5 }} />
                <Tabs defaultActiveKey="1">
                  <TabPane tab="For Team Members" key="1">
                    {isAdminOrHr && (
                      <div
                        style={{
                          flex: 1,
                          // display: 'flex',
                          flexDirection: 'column',
                          marginBottom: 10,
                          display: 'flex',
                        }}>
                        <Row style={{ alignItems: 'center', marginTop: 10 }}>
                          <Space>
                            <ControlOutlined style={{ color: 'black', fontSize: 20 }} />
                            <Typography.Title level={5}>Components</Typography.Title>
                          </Space>
                        </Row>
                        <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                        <Configurations
                          onChange={(val) => submitConfiguration(val, 'team')}
                          values={goalSummary?.configurations}
                        />
                      </div>
                    )}
                    <Row
                      style={{
                        alignItems: 'center',
                        marginTop: 20,
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}>
                      <Space>
                        <LikeOutlined style={{ color: 'black', fontSize: 20 }} />
                        <Typography.Title level={5}>Peer Reviews</Typography.Title>
                      </Space>
                      {isAdminOrHr && (
                        <Space>
                          <div style={{ display: 'flex', marginRight: 50 }}>
                            <Typography.Title style={{ marginRight: 50 }} level={5}>
                              Publish For Review
                            </Typography.Title>
                            <Switch
                              disabled={!isAdminOrHr && !isLeader && !isSupervisor}
                              checked={goalSummary?.publishForPeers}
                              onChange={() => publish('Peers')}
                            />
                          </div>
                        </Space>
                      )}
                    </Row>
                    <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                    <Space direction={'vertical'}>
                      <Typography>
                        Peer reviews will be automatically forwarded to the team lead for approval.
                        Once approved only, they will be visible for individuals
                      </Typography>
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          marginLeft: '20px',
                          marginRight: '20px',
                        }}>
                        {isAdminOrHr && (
                          <>
                            <Row style={{ alignItems: 'center' }}>
                              <Space>
                                <Typography.Title level={5}>Criteria Set</Typography.Title>
                              </Space>
                            </Row>
                            <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                            <Row>
                              <Col span={15}>
                                <Select
                                  disabled={!isAdminOrHr && !isLeader && !isSupervisor}
                                  style={{ display: 'block' }}
                                  onChange={(e: number) => {
                                    setValue(e);
                                    setCriteria(e);
                                  }}
                                  value={value}>
                                  {criteriaSet
                                    .map((e) => ({ id: e.id, value: e.name }))
                                    .map((value: any, index) => (
                                      <Select.Option key={index} value={value.id}>
                                        {value.value}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </Col>
                            </Row>
                            <Space size={25} />
                            <Row>
                              <Col span={18}>
                                {value !== undefined &&
                                  criteriaSet
                                    ?.find((e1) => e1.id == value)
                                    ?.criterias.map((e: any) => (
                                      <div
                                        key={e.id}
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          border: '1px solid rgba(56,54,48,.16)',
                                          marginTop: 5,
                                          padding: 5,
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}>
                                        <Text>{e.name}</Text>
                                      </div>
                                    ))}
                              </Col>
                            </Row>
                          </>
                        )}
                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 15,
                          }}>
                          <Typography.Title level={5}>Team members</Typography.Title>
                          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                          {team?.members?.map((memo, index) => (
                            <TeamUserPage
                              // disabled={!isAdminOrHr && !isLeader && !isSupervisor}
                              cycle={cycle ?? 0}
                              image={memo.image ?? ''}
                              userId={memo.id}
                              goalSummaryId={goalSummary?.id ?? 0}
                              key={index}
                              teamId={+params.id}
                              leader={false}
                              lastName={memo.lastName}
                              firstName={memo.firstName}
                              members={team?.members?.filter((e) => e.id !== memo.id)}
                              values={
                                goalSummary?.peerReview
                                  ?.filter((e) => e.user == memo.id)
                                  .map((e) => {
                                    return { reviewer: e.reviewer, status: e.status };
                                  }) ?? []
                              }
                              displayLabel={'Peers'}
                            />
                          ))}
                        </div>
                      </div>
                    </Space>
                    {isAdminOrHr && (
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          marginBottom: 10,
                        }}>
                        <Row
                          style={{
                            alignItems: 'center',
                            marginTop: 20,
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}>
                          <Space>
                            <Typography>Approver</Typography>
                            <SelectSearch
                              style={{ minWidth: 250 }}
                              values={userSet}
                              mode="multiple"
                              value={(goalSummary?.internalCustomerApprovers ?? []) as any}
                              onChange={(e: any) => {
                                setLoading(true);
                                if (goalSummary) {
                                  const approverIds = Array.isArray(e) ? e : [e];
                                  connection
                                    .patch(`goals-summary/approvers/${goalSummary.id}`, {
                                      approverIds,
                                    })
                                    .then(() => {
                                      setFetch(!fetch);
                                      setLoading(false);
                                    });
                                }
                              }}
                            />
                            <div style={{ display: 'flex', marginRight: 50 }}>
                              <Typography.Title style={{ marginRight: 50 }} level={5}>
                                Publish For Review
                              </Typography.Title>
                              <Switch
                                checked={goalSummary?.publishForInternalCustomers}
                                onChange={() => publish('InternalCustomers')}
                              />
                            </div>
                          </Space>
                        </Row>
                        <Divider style={{ marginTop: 10, marginBottom: 20 }} />
                      </div>
                    )}
                    {isAdminOrHr && (
                      <div
                        style={{
                          marginRight: 20,
                          marginLeft: 20,
                          display: 'block',
                        }}>
                        {goalSummary?.id && (
                          <InternalCustomerManger
                            internalCustomers={[...internalTeamCustomers, ...internalUserCustomers]}
                            teamSet={teamSet}
                            label={'Internal Customer'}
                            userSet={userSet}
                            criteriaSet={criteriaSet}
                            onChange={(reviewers) => {
                              setLoading(true);
                              connection
                                .patch(`goals/internalCustomer/${goalSummary.id}`, {
                                  reviewers,
                                  teamId: params.id,
                                })
                                .then(() => {
                                  setFetch(!fetch);
                                  setLoading(false);
                                });
                            }}
                          />
                        )}
                      </div>
                    )}
                  </TabPane>
                  {showTeamLeadsTab && (
                    <TabPane tab="For Team Leads" key="2">
                      {isAdminOrHr && (
                        <div
                          style={{
                            flex: 1,
                            // display: 'flex',
                            flexDirection: 'column',
                            marginBottom: 10,
                            display: 'flex',
                          }}>
                          <Row style={{ alignItems: 'center', marginTop: 10 }}>
                            <Space>
                              <ControlOutlined style={{ color: 'black', fontSize: 20 }} />
                              <Typography.Title level={5}>Components</Typography.Title>
                            </Space>
                          </Row>
                          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                          <Configurations
                            onChange={(val) => submitConfiguration(val, 'lead')}
                            values={goalSummary?.leadConfigurations}
                          />
                        </div>
                      )}
                      <Row
                        style={{
                          alignItems: 'center',
                          marginTop: 20,
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}>
                        <Space>
                          <ApartmentOutlined style={{ color: 'black', fontSize: 20 }} />
                          <Typography.Title level={5}>Subordinate Evaluation</Typography.Title>
                        </Space>
                        {isAdminOrHr && (
                          <Space>
                            <div style={{ display: 'flex', marginRight: 50 }}>
                              <Typography.Title style={{ marginRight: 50 }} level={5}>
                                Publish For Review
                              </Typography.Title>
                              <Switch
                                disabled={!isAdminOrHr && !isSupervisor}
                                checked={goalSummary?.publishForLeaderPeers}
                                onChange={() => publish('LeaderPeers')}
                              />
                            </div>
                          </Space>
                        )}
                      </Row>
                      <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                      {goalSummary?.id &&
                        team?.leads?.map((memo, index) => (
                          <Space direction={'vertical'} key={index} style={{ width: '100%' }}>
                            <UserNameView
                              name={`${memo.firstName} ${memo.lastName}`}
                              src={memo.image}
                              tags={false}
                            />
                            <SubordinateReviewManger
                              // disabled={!isAdminOrHr && !isSupervisor}
                              internalCustomers={[...subordinate]}
                              leadId={memo.id}
                              userSet={teamUsers.filter((e) => e.id !== memo.id)}
                              criteriaSet={criteriaSet}
                              onChange={(reviewers) => {
                                setLoading(true);
                                connection
                                  .patch(`goals/setLeaderCriteria/${goalSummary.id}`, {
                                    reviewers,
                                    userId: memo.id,
                                  })
                                  .then(() => {
                                    setFetch(!fetch);
                                    setLoading(false);
                                  });
                              }}
                            />
                          </Space>
                        ))}
                      {isAdminOrHr && (
                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: 10,
                          }}>
                          <Row
                            style={{
                              alignItems: 'center',
                              marginTop: 20,
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}>
                            <Space>
                              <TeamOutlined style={{ color: 'black', fontSize: 20 }} />
                              <Typography.Title level={5}>
                                Internal Customers For Leader
                              </Typography.Title>
                            </Space>
                            <Space>
                              <Typography>Approver</Typography>
                              <SelectSearch
                                disabled={true}
                                style={{ minWidth: 250 }}
                                values={userSet}
                                value={goalSummary?.internalCustomerApprover}
                                onChange={(e) => {
                                  setLoading(true);
                                  if (goalSummary) {
                                    connection
                                      .patch(`goals-summary/approver/${goalSummary.id}/${e}`)
                                      .then(() => {
                                        setFetch(!fetch);
                                        setLoading(false);
                                      });
                                  }
                                }}
                              />
                              <div style={{ display: 'flex', marginRight: 50 }}>
                                <Typography.Title style={{ marginRight: 50 }} level={5}>
                                  Publish For Review
                                </Typography.Title>
                                <Switch
                                  disabled={true}
                                  checked={goalSummary?.publishForInternalCustomers}
                                  onChange={() => publish('InternalCustomers')}
                                />
                              </div>
                            </Space>
                          </Row>
                          <Divider style={{ marginTop: 10, marginBottom: 20 }} />
                        </div>
                      )}
                      {isAdminOrHr && (
                        <div
                          style={{
                            marginRight: 20,
                            marginLeft: 20,
                            display: 'block',
                          }}>
                          {goalSummary?.id && (
                            <InternalCustomerManger
                              leader={true}
                              internalCustomers={[
                                ...internalTeamCustomers,
                                ...internalUserCustomers,
                              ].map((e) => ({
                                ...e,
                                weight: e?.leaderWeight ?? e?.weight,
                                key: e.id,
                              }))}
                              teamSet={teamSet}
                              label={'Internal Customer'}
                              userSet={userSet}
                              criteriaSet={criteriaSet}
                              onChange={(reviewers) => {
                                setLoading(true);
                                connection
                                  .patch(`goals/leader-internal-customer/${goalSummary.id}`, {
                                    reviewers,
                                    teamId: params.id,
                                  })
                                  .then(() => {
                                    setFetch(!fetch);
                                    setLoading(false);
                                  });
                              }}
                            />
                          )}
                        </div>
                      )}
                    </TabPane>
                  )}
                </Tabs>
              </div>
            </Spin>
          )}
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};
